import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DateAggregation, ChartDto } from 'src/app/shared/models/chart.model';
import { ConfigService } from 'src/app/shared/services/config-service';
import { TimeSeriesResponseDto } from 'src/app/shared/models/time-series-response.model';
import { UserStore } from 'src/app/shared/user/store/user.store';

export interface GetCompanyTurnoverParams {
  dateFrom: Date;                 
  dateTo: Date;
  aggregateBy: DateAggregation;  
  costCenterIds?: string[];       
}

export interface GetCostCenterTurnoverParams {
  dateFrom: Date;
  dateTo: Date;
  costCenterIds?: string;
  includeChildren: boolean;
}

export interface TurnoverByCostCenterItemDto {
  costCenterId: number;
  name: string;
  actualSales: number;
  targetSales: number;
  difference: number;
  children?: TurnoverByCostCenterItemDto[] | null;
}

export interface TurnoverByCostCenterResponseDto {
  dateFrom: string;
  dateTo: string;
  items: TurnoverByCostCenterItemDto[];
}

@Injectable({ providedIn: 'root' })
export class CompanyEarningsService {

  private readonly basePath = 'companyearnings/turnover';

  private configService = inject(ConfigService);
  private userStore = inject(UserStore);

  constructor(private readonly http: HttpClient) {}

  getCompanyTurnover(params: GetCompanyTurnoverParams): Observable<TimeSeriesResponseDto> {
    let httpParams = new HttpParams()
      .set('dateFrom', this.toIsoDate(params.dateFrom))
      .set('dateTo', this.toIsoDate(params.dateTo))
      .set('aggregateBy', String(params.aggregateBy));

    if (params.costCenterIds?.length) {
      httpParams = httpParams.set('costCenterIds', params.costCenterIds.join(','));
    }

    return this.http.get<TimeSeriesResponseDto>(`${this.configService.getUrlNectaOneApi()}/${this.userStore.activeTenant()?.tenantId}/${this.basePath}`, { params: httpParams });
  }


getCostCenterTurnover(params: GetCostCenterTurnoverParams): Observable<TurnoverByCostCenterResponseDto> {
  let httpParams = new HttpParams()
    .set('dateFrom', this.toIsoDate(params.dateFrom))
    .set('dateTo', this.toIsoDate(params.dateTo))
    .set('includeChildren', String(params.includeChildren));

  if (params.costCenterIds) {
    httpParams = httpParams.set('costCenterIds', params.costCenterIds);
  }

  return this.http.get<TurnoverByCostCenterResponseDto>(
    `${this.configService.getUrlNectaOneApi()}/${this.userStore.activeTenant()?.tenantId}/companyearnings/turnover/by-costcenter`,
    { params: httpParams }
  );
}

  
  private toIsoDate(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
}
